import { Card, Stack, Text, Spinner } from '@chakra-ui/react';
import { Folder } from '../../lib/state/ViewTypes';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Node } from '../../lib/api/APITypes';
import { useLazyGetNodeQuery } from '../../lib/api/GraphAPI';
import StyledButton from '@/components/ui/styledButton';

export default function FolderItem(props: { folder: Folder }) {
  const navigate = useNavigate();

  const [nodesToDisplay, setNodesToDisplay] = useState<{ [key: string]: Node }>({});
  const [nodeQuery] = useLazyGetNodeQuery();
  const [loading, setLoading] = useState(false);
  const NUMBER_NODES_TO_DISPLAY = 3;

  useEffect(() => {
    if (props.folder.documents.length === 0) {
      setNodesToDisplay({});
      return;
    }
    setLoading(true);
    setNodesToDisplay({});
    for (let i = 0; i < NUMBER_NODES_TO_DISPLAY; i++) {
      if (i < props.folder.documents.length && props.folder.documents[i] != null) {
        nodeQuery(props.folder.documents[i]).then((res) => {
          if (res.data) {
            setNodesToDisplay((prev) => {
              const newNodes = { ...prev };
              newNodes[res.data!.elementId] = res.data!;
              return newNodes;
            });
          }
          if (i === Math.min(NUMBER_NODES_TO_DISPLAY, props.folder.documents.length) - 1) {
            setLoading(false);
          }
        });
      }
    }
  }, [props.folder.documents]);

  return (
    <Card.Root border="none" backgroundColor="cardDefault" width="390px" height="fit-content">
      <Card.Header>
        <Stack>
          <Text color="secondaryText" fontSize={'lg'} fontWeight="bold" key={props.folder.id}>
            {props.folder.name}
          </Text>
        </Stack>
      </Card.Header>
      <Card.Body>
        <Stack direction="column" width="100%">
          <Text color="secondaryText" fontSize="sm">
            # of Documents: {props.folder.documents.length}
          </Text>
          {loading ? (
            <Spinner />
          ) : (
            <>
              {Object.values(nodesToDisplay).map((node) => (
                <Text key={node.elementId} fontSize={'md'}>
                  {node.label.split('CASE OF').at(-1)}
                </Text>
              ))}
              {props.folder.documents.length > NUMBER_NODES_TO_DISPLAY && (
                <Text fontSize="sm">
                  ...and {props.folder.documents.length - NUMBER_NODES_TO_DISPLAY} more
                </Text>
              )}
            </>
          )}
        </Stack>
      </Card.Body>
      <Card.Footer justifyContent="end">
        <StyledButton
          variant="solid"
          text="Open Folder"
          onClick={() => navigate(`/saved_cases/${props.folder.id}`)}
        />
      </Card.Footer>
    </Card.Root>
  );
}
